import { Component, OnInit } from '@angular/core';
import { BackendService } from '../../service/backend.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../service/user.service';
import { PurchaseConfirmation, PurchaseService } from '../../service/purchase.service';
import { NgIf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

interface Purchase {
  email: string,
  refNumber: string,
  status: string,
  type: string,
  productName: string,
  company: string,
  username: string,
  street: string,
  zip: string,
  city: string,
  country: string,
}

@Component({
  selector: 'app-stripe-checkout',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule
  ],
  templateUrl: './stripe-checkout.component.html',
  styleUrl: './stripe-checkout.component.scss'
})
export class StripeCheckoutComponent implements OnInit {
  purchase: PurchaseConfirmation = {success: false, statusCode: 0};

  constructor(
    private readonly backendService: BackendService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly purchaseService: PurchaseService
  ) {

  }

  ngOnInit(): void {
    console.log('ActivatedRoute snapshot:', this.route.snapshot.url);
    console.log('Params:', this.route.snapshot.params);
    this.route.paramMap.subscribe(params => {
      console.log('ParamMap:', params);
      const sessionId = params.get('sessionId');
      if (sessionId) {
        this.fetchPurchase(sessionId);
      }
    });
    // log stan zalogowania:
    console.log('Is user logged in:', this.userService.isUserLoggedIn());
  }


  async fetchPurchase(sessionId: string): Promise<void> {
    const record = await this.purchaseService.getPurchaseByStripeSessionId(sessionId);
    if (record.success) {
      this.purchase = record;
    }
  }
}
